// src/services/landingPageService.js
import omniStackApi from './omniStackApi';

const LandingPageService = {
    /**
     * Get landing page data by hash ID
     * @param {string} hashId - The restaurant hash ID
     * @returns {Promise} - The landing page data
     */
    getLandingPage(hashId) {
        return omniStackApi.get(`/api/landing-page/${hashId}`);
    },

    /**
     * Track an action on the landing page
     * @param {Object} trackingData - Data for tracking the action
     * @param {string} trackingData.hashId - Restaurant hash ID
     * @param {string} trackingData.actionType - Type of action (PAGE_VIEW, GOOGLE_REVIEW_CLICK, APP_LINK_CLICK, REGISTRATION_START)
     * @param {string} [trackingData.userAgent] - User agent string
     * @param {string} [trackingData.referrer] - Referrer URL
     * @returns {Promise} - The response from the server
     */
    trackAction(trackingData) {
        return omniStackApi.post('/api/landing-page/track', trackingData);
    }
};

export default LandingPageService;